import { IMagicUserLogin, IUserCreate, IUserLogin, IUserResetPassword } from '@app-types/api/user.types';
import http from '@clients/http.client';
import { AxiosResponse } from 'axios';
import { claimAttribution, getAttributionTrackingId } from '@services/attribution/attribution';

// The claim runs in the background so attribution never delays login or account refresh.
function withAttribution(response: AxiosResponse<any>) {
  void claimAttribution(response.data && response.data.authorization);
  return response;
}

export async function createUser(data: IUserCreate) {
  const trackingId = await getAttributionTrackingId();
  return http.post('https://api.varannanvecka.app:443/v1/account', { ...data, trackingId }).then(withAttribution);
}

export function getUser() {
  return http.get('https://api.varannanvecka.app:443/v1/account').then(withAttribution);
}


export function uploadOfflineEventAnalysis(data:{imageData:Blob, auth:string, familyId:number, action:string}) {

    return http.post('https://api.varannanvecka.app:443/v1/upload/ai/'+data.familyId+'/'+data.action, data.imageData, {
      headers: {
        Authorization: data.auth
      }
    });
}

export function loginUser(data: IUserLogin) {
  // return http.post('http://localhost:8080/v1/authentication', data);
  return http.post('https://api.varannanvecka.app:443/v1/authentication', data).then(withAttribution);
}

export function loginMagicUser(data: IMagicUserLogin) {
  // return http.put('http://localhost:8080/v1/magic', {token:data.token});
  return http.post('https://api.varannanvecka.app:443/v1/magic', {token:data.token}).then(withAttribution);
}

export function resetPassword(data: IUserResetPassword) {
  return http.post('https://api.varannanvecka.app:443/v1/reset', data);
}

export function signupInvite(data: IUserCreate) {
  const dataCopy = Object.assign({}, data);
  dataCopy.token = undefined;
  // return http.post(`http://localhost:8080/v1/invites/${data.token}`, dataCopy);
  return http.post(`https://api.varannanvecka.app:443/v1/invites/${data.token}`, dataCopy).then(withAttribution);
}

export function getInvitedUser(token: string) {
  return http.get(`https://api.varannanvecka.app:443/v1/invites/${token}`);
}

export function storeInviteToken(token: string) {
  return http.put(`https://api.varannanvecka.app:443/v1/inv/${token}`);
}

export function getInviteToken(ip: string) {
  return http.get(`https://api.varannanvecka.app:443/v1/inv/${ip}`);
}

export function storeCampaignToken(token: string) {
  // return http.put(`http://localhost:8080/v1/campaign/${token}`);
  return http.put(`https://api.varannanvecka.app:443/v1/campaign/${encodeURIComponent(token)}`);
}

export function getCampaignToken(email: string) {
  // return http.get(`http://localhost:8080/v1/campaign/${email}`);
  return http.get(`https://api.varannanvecka.app:443/v1/campaign/${email}`);
}

export function specialOffer(familyId:number, accountId:number, offer: string) {
  // return http.put(`http://localhost:8080/v1/testperiod/${familyId}/${accountId}/${offer}`);
  return http.put(`https://api.varannanvecka.app:443/v1/testperiod/${familyId}/${accountId}/${offer}`);
}



// WEBPACK FOOTER //
// ./src/services/user/user.http.ts